module.exports = __webpack_public_path__ + "static/media/award_type_direct.f9947654.svg";